import i18n from "i18next";
import { useContext } from "react";

import { APIContext } from "./APIProvider";
import { request } from "./request";

export const useAPIRequest = () => {
  const { domain, token } = useContext(APIContext);

  return async <Response extends unknown>(
    path: string,
    init: RequestInit = { method: "GET" }
  ) => {
    const url = [domain, path].join("");

    return request<Response>(url, {
      token,
      ...init,
      headers: {
        ...init.headers,
        "Accept-Language": i18n.language,
      },
    });
  };
};
